import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, CircularProgress, Box } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { AuthPage } from './components/Auth/AuthPage';
import { AdminDashboard } from './components/Admin/AdminDashboard';
import { VeterinaireDashboard } from './components/Veterinaire/VeterinaireDashboard';
import { ProprietaireDashboard } from './components/Proprietaire/ProprietaireDashboard';

// Thème VetCare avec couleurs vétérinaires
const theme = createTheme({
  palette: {
    primary: {
      main: '#2e7d32', // Vert vétérinaire
      light: '#60ad5e',
      dark: '#005005',
    },
    secondary: {
      main: '#1976d2', // Bleu médical
      light: '#63a4ff',
      dark: '#004ba0',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
  },
});

const AppContent: React.FC = () => {
  const { user, loading, isAuthenticated, isAdmin, isVeterinaire, isProprietaire } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <AuthPage />;
  }

  // Redirection selon le rôle de l'utilisateur
  if (isAdmin) {
    return <AdminDashboard />;
  } else if (isVeterinaire) {
    return <VeterinaireDashboard />;
  } else if (isProprietaire) {
    return <ProprietaireDashboard />;
  }

  return <AuthPage />;
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
